export default __webpack_public_path__ + "static/floor-plan-PH3AR-afa23f628fd6a94a8160ef8b8d93855e.pdf";